import { createGlobalState } from 'react-use';

type ActiveSpectraTimestamp = number | null;
const useGlobalActiveTimestampState = createGlobalState<ActiveSpectraTimestamp>(null);
export const useActiveSpectraTimestamp = () => useGlobalActiveTimestampState();

type ActiveSpectraTimeLabel = string | null;
const useGlobalActiveTimeLabelState = createGlobalState<ActiveSpectraTimeLabel>(null);
export const useActiveSpectraTimeLabel = () => useGlobalActiveTimeLabelState();

type ActiveSpectraHourIndex = number;
const useGlobalActiveSpectraHourIndexState = createGlobalState<ActiveSpectraHourIndex>(-1);
export const useActiveSpectraHourIndex = () => useGlobalActiveSpectraHourIndexState();

type ActiveSpectraDayIndex = number;
const useGlobalActiveSpectraDayIndexState = createGlobalState<ActiveSpectraDayIndex>(-1);
export const useActiveSpectraDayIndex = () => useGlobalActiveSpectraDayIndexState();

type ActiveSpectraLeftPosition = number;
const useGlobalActiveLeftPositionState = createGlobalState<ActiveSpectraLeftPosition>(-1);
export const useActiveSpectraLeftPosition = () => useGlobalActiveLeftPositionState();

type ActiveSpectraLeftNowPosition = number;
const useGlobalActiveSpectraLeftNowPositionState =
  createGlobalState<ActiveSpectraLeftNowPosition>(-1);
export const useActiveSpectraLeftNowPosition = () => useGlobalActiveSpectraLeftNowPositionState();

const globalVariables = {
  useActiveSpectraDayIndex,
  useActiveSpectraHourIndex,
  useActiveSpectraTimestamp,
  useActiveSpectraTimeLabel,
  useActiveSpectraLeftPosition,
  useActiveSpectraLeftNowPosition,
};

export default globalVariables;
